function animateHeadings(
  sectionClass = '',
  headingSelector = '[data-animate="heading"]'
) {
  const section = document.querySelector(sectionClass);
  if (!section) {
    console.warn(`Section with class "${sectionClass}" not found.`);
    return;
  }

  const headings = section.querySelectorAll(headingSelector);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log('Animating heading:', entry.target);
          entry.target.classList.remove('oma:translate-y-8', 'oma:opacity-0');
          entry.target.classList.add('oma:translate-y-0', 'oma:opacity-100');

          observer.unobserve(entry.target); // Stop observing once the animation is done
        }
      });
    },
    { threshold: 0.2 }
  );

  headings.forEach((heading) => observer.observe(heading));
}
